import { render } from "./permissionSettingWebPage.vue?vue&type=template&id=51e66614&scoped=true"
import script from "./permissionSettingWebPage.vue?vue&type=script&lang=js"
export * from "./permissionSettingWebPage.vue?vue&type=script&lang=js"

import "./permissionSettingWebPage.vue?vue&type=style&index=0&id=51e66614&scoped=true&lang=css"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51e66614"]])

export default __exports__